document.querySelectorAll('[data-master-pdp]').forEach((root) => {
  const form = root.querySelector('.ss-master-pdp__form');
  if (!form) return;
  if (root.hasAttribute('data-master-skeleton')) form.addEventListener('submit', (event) => event.preventDefault());

  const quantity = form.querySelector('[data-master-quantity]');
  const pointsTotal = root.querySelector('[data-master-points-total]');
  const planInput = form.querySelector('[data-master-plan-input]');
  const planSelect = form.querySelector('[data-master-plan-select]');
  const pointsPerUnit = Number(root.dataset.pointsPerUnit || 0);
  const skeleton = root.hasAttribute('data-master-skeleton');
  const quantityCaption = root.querySelector('[data-master-quantity-caption]');
  const unitSingular = root.dataset.unitSingular || '[UNIT]';
  const unitPlural = root.dataset.unitPlural || '[UNIT]';

  const setPlan = () => {
    if (!planInput || !planSelect) return;
    const subscribed = form.querySelector('input[name="master_purchase"]:checked')?.value === 'subscription';
    const selected = planSelect.selectedOptions[0];
    planInput.value = subscribed ? selected?.value || '' : '';
  };

  if (root.hasAttribute('data-master-pack-mode')) {
    const cards = Array.from(form.querySelectorAll('[data-master-pack-card]'));
    const baseOptions = Array.from(form.querySelectorAll('[data-master-base-option]'));

    form.querySelectorAll('input[name="master_pack"]').forEach((input) => input.addEventListener('change', () => {
      form.querySelector('input[name="id"]').value = input.value;
      if (quantity) quantity.value = '1';
      const url = new URL(window.location.href);
      url.searchParams.set('variant', input.value);
      window.location.assign(url.toString());
    }));

    baseOptions.forEach((select) => select.addEventListener('change', () => {
      const selectedPack = form.querySelector('input[name="master_pack"]:checked')?.closest('[data-master-pack-card]')?.dataset.packValue;
      const matchesBaseOptions = (card) => baseOptions.every((optionSelect) => {
        const position = Number(optionSelect.dataset.optionPosition || 0);
        return card.dataset[`option${position}`] === optionSelect.value;
      });
      let target = cards.find((card) => card.dataset.packValue === selectedPack && matchesBaseOptions(card) && !card.querySelector('input')?.disabled);
      if (!target) target = cards.find((card) => matchesBaseOptions(card) && !card.querySelector('input')?.disabled);
      const input = target?.querySelector('input[name="master_pack"]');
      if (!input) return;
      const url = new URL(window.location.href);
      url.searchParams.set('variant', input.value);
      window.location.assign(url.toString());
    }));

    form.addEventListener('submit', () => { if (quantity) quantity.value = '1'; });
  } else {
    const setQuantity = (value) => {
      const next = Math.max(1, Math.floor(Number(value) || 1));
      quantity.value = next;
      form.querySelectorAll('.ss-master-pdp__quantity-option').forEach((option) => {
        const selected = Number(option.querySelector('input').value) === next;
        option.classList.toggle('is-active', selected);
        option.querySelector('input').checked = selected;
      });
      if (quantityCaption) quantityCaption.textContent = `${next} ${next === 1 ? unitSingular : unitPlural}`;
      if (pointsTotal && !skeleton) pointsTotal.textContent = `${pointsPerUnit * next} Punkte`;
    };

    form.querySelector('[data-master-decrease]')?.addEventListener('click', () => setQuantity(Number(quantity.value) - 1));
    form.querySelector('[data-master-increase]')?.addEventListener('click', () => setQuantity(Number(quantity.value) + 1));
    quantity?.addEventListener('change', () => setQuantity(quantity.value));
    form.querySelectorAll('.ss-master-pdp__quantity-option input').forEach((input) => input.addEventListener('change', () => setQuantity(input.value)));
  }

  form.querySelectorAll('input[name="master_purchase"]').forEach((input) => input.addEventListener('change', setPlan));
  planSelect?.addEventListener('change', setPlan);
  setPlan();

  form.querySelector('[data-master-variant]')?.addEventListener('change', (event) => {
    const url = new URL(window.location.href);
    url.searchParams.set('variant', event.target.value);
    window.location.assign(url.toString());
  });

  root.querySelectorAll('[data-master-thumb]').forEach((thumb) => thumb.addEventListener('click', () => {
    const id = thumb.dataset.masterThumb;
    root.querySelectorAll('[data-master-thumb]').forEach((item) => {
      const active = item === thumb;
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-pressed', String(active));
    });
    root.querySelectorAll('[data-master-media]').forEach((media) => media.classList.toggle('is-hidden', media.dataset.masterMedia !== id));
  }));
});
